import httpClient from '@/httpClient'
import type {
  OnboardingScreenEligibilityResponse,
  ViewOnboardingScreenRequest
} from './postMatch.types'
import { useError } from '@/composables/useError'

const BASE_URL = '/api/onboarding'

export const fetchOnboardingScreensEligibility =
  async (): Promise<OnboardingScreenEligibilityResponse> => {
    const { handleError } = useError()
    const _endpoint = `${BASE_URL}/GetScreenEligibility`

    try {
      const _response =
        await httpClient.get<OnboardingScreenEligibilityResponse>(_endpoint)

      return _response.data
    } catch (error) {
      handleError({ error: error, action: 'fetchOnboardingScreensEligibility' })

      throw error
    }
  }

export const setOnboardingScreenViewed = async (
  payload: ViewOnboardingScreenRequest
): Promise<number> => {
  const { handleError } = useError()
  const _endpoint = `${BASE_URL}/view`

  try {
    const _response = await httpClient.post(_endpoint, payload)

    return _response.data
  } catch (error) {
    handleError({ error: error, action: 'setOnboardingScreenViewed' })

    throw error
  }
}
